import { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { DirectUploadsPanel } from '@/components/youtube/upload/DirectUploadsPanel';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';

export function AppLayout() {
  const [isMobile, setIsMobile] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="min-h-screen flex bg-background">
      {!isMobile && (
        <aside
          className="sticky top-0 h-screen border-r border-border bg-card transition-all duration-200 shrink-0 z-10"
          style={{ width: collapsed ? 72 : 240 }}
        >
          <Sidebar collapsed={collapsed} />
        </aside>
      )}

      <div className="flex flex-col flex-1 min-w-0">
        <Topbar
          isMobile={isMobile}
          collapsed={collapsed}
          onToggleCollapse={() => setCollapsed((value) => !value)}
          drawerOpen={drawerOpen}
          onDrawerChange={setDrawerOpen}
        />
        <main className="flex-1 min-w-0">
          <Outlet />
        </main>
      </div>
      <DirectUploadsPanel />
    </div>
  );
}
